import { ANALOG_CR_YEAR_START } from '@/components/expAnalogs/const'

export const CR_ARGUMENT_TYPES = [
  { value: 'thesis', text: '1. Тезис' },
  { value: 'comment', text: '2. Комментарий / Приложение' },
]

export const CR_UDD_ITEMS = [1, 2, 3, 4, 5]
export const CR_UUR_ITEMS = ['A', 'B', 'C']

export const DEFAULT_CR_ARGUMENT = () => ({
  type: 'thesis',
  text: '',
  hasUurUdd: false,
  udd: null,
  uur: null,
})

export const DEFAULT_SUMMARY_CR_ITEM = () => ({
  name: '',
  crNumber: '',
  year: '',
  reviewBy: '',
  arguments: [DEFAULT_CR_ARGUMENT()],
})

export const DEFAULT_CR_PRESENCE = () => ({
  hasInCr: false,
  items: [],
})

export function crYearItems(extraYear) {
  const currentYear = new Date().getFullYear()
  const years = []
  for (let y = ANALOG_CR_YEAR_START; y <= currentYear + 5; y++) {
    years.push(y)
  }
  const extra = Number(extraYear)
  if (extra && !years.includes(extra)) years.push(extra)
  return years.sort((a, b) => b - a)
}

export function normalizeCrPresence(raw, legacyCrNames = '') {
  if (raw && typeof raw === 'object' && Array.isArray(raw.items)) {
    return {
      hasInCr: !!raw.hasInCr,
      items: raw.items.map(normalizeCrItem),
    }
  }
  const legacy = String(legacyCrNames || '').trim()
  return {
    hasInCr: !!legacy,
    items: [],
  }
}

function normalizeCrItem(item) {
  const args =
    Array.isArray(item?.arguments) && item.arguments.length
      ? item.arguments.map(normalizeCrArgument)
      : [DEFAULT_CR_ARGUMENT()]
  return {
    name: item?.name ?? '',
    crNumber: item?.crNumber != null ? String(item.crNumber) : '',
    year: item?.year != null ? String(item.year) : '',
    reviewBy: item?.reviewBy != null ? String(item.reviewBy) : '',
    arguments: args,
  }
}

function normalizeCrArgument(arg) {
  return {
    type: arg?.type === 'comment' ? 'comment' : 'thesis',
    text: arg?.text ?? '',
    hasUurUdd: !!arg?.hasUurUdd,
    udd: arg?.udd != null && arg.udd !== '' ? Number(arg.udd) : null,
    uur: arg?.uur ? String(arg.uur) : null,
  }
}

/** Строка заголовка КР для таблицы и представления */
export function formatCrLine(item) {
  const num = item.crNumber ? `№${item.crNumber}` : ''
  const title = item.name ? `«${item.name}»` : ''
  const year = item.year ? ` (${item.year} г.)` : ''
  const review = item.reviewBy
    ? ` — пересмотр не позднее ${item.reviewBy} г.`
    : ''
  const core = ['КР', num, title].filter(Boolean).join(' ')
  return `${core}${year}${review}`.trim()
}

/** Вывод о качестве доказательств по паре УДД + УУР (как в подписи к КР). */
export function getUddUurEvidenceConclusion(udd, uur) {
  if (udd == null || !uur) return ''
  const d = Number(udd)
  const u = String(uur).toUpperCase()
  if (!Number.isFinite(d) || !CR_UUR_ITEMS.includes(u)) return ''

  if (d === 5 && u === 'C') return 'экспертное мнение'
  if (d >= 1 && d <= 2) return 'доказательства убедительные'
  if (d >= 3 && d <= 4) return 'недостаточная убедительность'
  return ''
}

export function formatArgumentUurUdd(udd, uur) {
  if (udd == null && !uur) return ''

  const conclusion = getUddUurEvidenceConclusion(udd, uur)
  if (udd != null && uur) {
    const label = `${udd}${String(uur).toUpperCase()}`
    return conclusion ? `(${label} — ${conclusion})` : `(${label})`
  }

  const parts = []
  if (udd != null) parts.push(`УДД — ${udd}`)
  if (uur) parts.push(`УУР — ${uur}`)
  return parts.length ? `(${parts.join('; ')})` : ''
}

export function formatCrItemPresentation(item) {
  const lines = [formatCrLine(item)]
  const theses =
    item.arguments?.filter(a => a.type === 'thesis' && String(a.text || '').trim()) ||
    []
  const comments =
    item.arguments?.filter(
      a => a.type === 'comment' && String(a.text || '').trim()
    ) || []

  if (theses.length) {
    lines.push('Тезисы:')
    theses.forEach((a, i) => {
      const suffix = a.hasUurUdd
        ? ` ${formatArgumentUurUdd(a.udd, a.uur)}`
        : ''
      lines.push(`${i + 1}. ${String(a.text).trim()}${suffix}`)
    })
  }
  if (comments.length) {
    lines.push('Комментарии / приложения:')
    comments.forEach((a, i) => {
      const suffix = a.hasUurUdd
        ? ` ${formatArgumentUurUdd(a.udd, a.uur)}`
        : ''
      lines.push(`${i + 1}. ${String(a.text).trim()}${suffix}`)
    })
  }
  return lines.join('\n')
}

/** Текст блока «Наличие в КР» для Word и превью */
export function formatCrPresencePresentation(crPresence, legacyCrNames = '') {
  const state = normalizeCrPresence(crPresence, legacyCrNames)
  if (!state.hasInCr) return 'Нет.'
  if (!state.items.length) {
    const legacy = String(legacyCrNames || '').trim()
    return legacy || 'Нет.'
  }
  return state.items.map(formatCrItemPresentation).join('\n\n')
}
